<template>
    <body>
        <div v-if="requestBusy && !requestOverlayText" id="loading-overlay">
            <div class="loader"></div>
        </div>
        <div v-if="requestOverlayText" id="request-overlay" class="modal in" tabindex="-1" role="dialog" aria-hidden="true" style="display:block; z-index: 99999; background-color: #16093dfa">
            <div style="margin-top: 320px">
                <div>
                    <div style="text-align: center">
                        <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                        <br />
                        <br />
                        <p style="color: white; ">{{ requestOverlayText }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="requestErrorCode !== null" id="request-error-overlay" class="modal in" tabindex="-1" role="dialog" aria-hidden="true">
            <div style="margin-top: 280px">
                <div>
                    <div style="text-align: center">
                        <div v-if="requestErrorCode == 0">
                            <i class="fa fa-5x fa-exclamation-triangle text-white mb-3" />
                            <p class="error-title">Network Connection Error</p>
                            <p class="error-description">We're having trouble processing your request. Please check your internet connection and try again</p>
                            <button class="btn btn-danger" v-on:click="$router.go()">RETRY</button>
                        </div>
                        <div v-else-if="requestErrorCode == 404">
                            <i class="fa fa-5x fa-exclamation-triangle text-white mb-3" />
                            <p class="error-title">Resource not found</p>
                            <p class="error-description">We could not locate the resource you requested</p>
                            <a class="btn btn-danger" href="/">BACK</a>
                        </div>
                        <div v-else>
                            <i class="fa fa-5x fa-exclamation-triangle text-white mb-3" />
                            <p class="error-title">Error: {{ requestErrorCode }}</p>
                            <p class="error-description">Please try again or send an email to support@elevatex.tech</p>
                            <button class="btn btn-danger" v-on:click="$router.go()">RETRY</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <header-component />
        <router-view />
    </body>
</template>
<style>
    #request-error-overlay {
        display: block;
        z-index: 99999;
        background-color: #620d0dfa;
    }

    .error-title {
        color: white;
        font-size: 24px;
    }

    .error-description {
        color: white;
        padding-top: 10px;
        padding-bottom: 10px;
        font-size: 18px;
    }

    html{
        height: 100%;
    }

    body{
        min-height: 100%;
    }

</style>

<script>
    import HeaderComponent from "./components/HeaderComponent";

    export default {
        name: 'app',
        components: { HeaderComponent},
        computed: {
            requestOverlayText() { return this.$store.state.requestOverlayText; },
            requestErrorCode() { return this.$store.state.requestErrorCode; },
            requestBusy() { return this.$store.state.requestBusy; },
        },
        mounted() {
        }
    }
</script>